// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1PYdl","buttons":"RemoveExpirationActionButtons_buttons__2TuLd"};